import store from './store';
import axios from 'axios';
import Cookies from 'universal-cookie';
import history from './utils/history';

import { API_URL, DEFAULT_PRODUCT_IMAGE } from './constants';
import { getProductsToOrder, getAllProducts, getAllProductsIfOnePlace, clearCartLocal, getProductIngredients } from './products/actions/products.action';
import { getOrders, setDisabledMakeOrderButton } from './products/actions/products.action';
import { getCategoriesHierarchy } from './categories/actions/categories.action';
import { getRegions } from './regions/regions.actions';
import { listLanguages, changeLanguage } from './language/actions/language.action';
import { setCurrentUser, getUserOrders } from './users/actions/users.actions';
import { getSettings } from './settings/actions/settings.action';
import { getPlaces, verifyOpenedPlace, setChosenPlace } from './places/actions/places.actions';
import { GET_PLACES } from './places/actions/types';
import { setClient } from './client/client.actions';
import { showHeaderCategory } from './categories/actions/categories.action';
import {
    setCartModalOpenedState, setTermsDialogOpened, setPrivacyPolicyDialogOpened, setDialTooltipState,
    setBottomSpeedDialTooltipUserNeedsAndBillWantedState, setBottomSpeedDialTooltipState, setUserNeedsModalState
} from './menu/menu.actions'
import { setLoginModalOpened, setRegisterModalOpened, setProfileModalOpened, validateUserToken, getTables } from './users/actions/users.actions';
import { setOrderModalState } from './qr-scan/actions/scan.actions';
import { getGeneralPromotions } from './general_promotions/actions/general_promotions.actions';

import { getRegisteredUserDiscounts } from './registered_user_discounts/actions/registered_user_discounts.actions'
import { getFutureOrdersCount } from './future_orders_count/actions/future_orders.actions'

import Utils from './utils/Utils';
import Auth from './utils/Auth';
import jwt from 'jsonwebtoken';

import setCustomClientHeader from './utils/setCustomClientHeader';
import setCustomPlaceHeader from './utils/setCustomPlaceHeader';
import setTablHeader from './utils/setTablHeader';
import setAppUltimateHeader from './utils/setAppUltimateHeader';
import setAuthorizationToken from './utils/setAuthorizationToken';
import { getUserNeeds } from './user-needs/actions/userneeds.action'
import { getBusyDatesForReservations } from './reservations/actions/reservations.actions';
import { getAccumulatedOrderAmountSetting } from './accumulated_order_amount_setting/actions/accumulated_order_amount_setting.actions';
const cookies = new Cookies();

setTablHeader();
// this is set in VerifyTokenPage after /t/$token?app_ultimate=1 which comes after scanning a token from the tabl app. Used in server apiRoutes.js
if(window.localStorage.getItem('app_ultimate')) {
    setAppUltimateHeader();
}


//if user logged; Sets the token on every refresh
if (Auth.getAuthUserToken()) {
    setAuthorizationToken(Auth.getAuthUserToken());
    store.dispatch(setCurrentUser(jwt.decode(Auth.getAuthUserToken())));
}
// export default setup => () => {

store.dispatch(validateUserToken());


// let clientSlug = document.location.pathname.split("/")[1];

history.listen(location => {
    if (history.action === 'POP') {

        store.dispatch(showHeaderCategory(false));

        store.dispatch(setLoginModalOpened(false));
        store.dispatch(setRegisterModalOpened(false));
        store.dispatch(setProfileModalOpened(false));

        store.dispatch(setOrderModalState(0)); //OrderModal
        store.dispatch(setDisabledMakeOrderButton(false)); //OrderModalButton
        store.dispatch(setCartModalOpenedState(false)); //CartModal
        store.dispatch(setTermsDialogOpened(false)); // Terms Dialog Modal
        store.dispatch(setPrivacyPolicyDialogOpened(false)); // Privacy Policy Dialog Modal

        store.dispatch(setDialTooltipState(false)); // Dial Tooltip Top Left

        store.dispatch(setBottomSpeedDialTooltipState(false)); // Bottom speed Dial
        store.dispatch(setBottomSpeedDialTooltipUserNeedsAndBillWantedState(false)); // Bottom speed Dial With user needs and bill wanted

        // User needs modal 
        store.dispatch(setUserNeedsModalState(false))

    } else if (history.action === 'PUSH') {
        // store.dispatch(verifyOpenedPlace(null, store.getState().places.chosen_place))
    }
})

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    // dev code

    let clientSlug = document.location.pathname.split("/")[1];

    if (clientSlug) {
        axios.get(API_URL + 'clients/' + clientSlug)
            .then(res => {

                if (res.data) {
                    setCustomClientHeader(res.data.id);

                    let places = res.data.places;
                    if (places && Object.values(places).length > 0) {
                        // places = places.filter(p => p.visible_for_online_orders == 1);
                        places = places.filter(p => p.active == 1 && p.visible_for_online_orders == 1);
                    }
                    
                    store.dispatch({
                        type: GET_PLACES,
                        payload: places,
                    });

                    store.dispatch(setClient(res.data));

                    let chosenPlace = 0;
                    // FOR redirect after payment; ppid = payment place id
                    const params = new URLSearchParams(window.location.search)
                    if(params.has('payment') && params.has('ppid')) {
                        chosenPlace = params.get('ppid');
                    }

                    if (places.length == 1 || chosenPlace != 0 || (Auth.isTabletMode() && Auth.getOpenedPlace())) {
                        let placeId;
                        if (Auth.isTabletMode() && Auth.getOpenedPlace() && Auth.getOpenedPlace() != 0) {
                            placeId = Auth.getOpenedPlace();
                        } else {
                            placeId = chosenPlace ? chosenPlace : places[0].id
                        }

                        if(document.location.href.includes('fernandez')) {
                            setCustomPlaceHeader(placeId);  // only for dev and don fernandez - защото е през iframe и на сафари Не работят кукитата 
                        }

                        store.dispatch(verifyOpenedPlace(placeId)); // if place is different -> clears local card, orders and token

                        store.dispatch(setChosenPlace(placeId));

                        store.dispatch(getAllProducts(0, placeId));
                        store.dispatch(getCategoriesHierarchy(placeId));
                        store.dispatch(getSettings(placeId));
                        store.dispatch(getProductIngredients());
                        store.dispatch(listLanguages());
                        store.dispatch(getRegions());
                        store.dispatch(getUserNeeds()); //only for dev, if prod the req is only if spot in UserNeedsModal.js

                        store.dispatch(getGeneralPromotions());
                        store.dispatch(getRegisteredUserDiscounts());
                        store.dispatch(getFutureOrdersCount());


                        store.dispatch(getUserOrders());

                        if(Auth.hasAccess("WAITER")) {
                            store.dispatch(getTables());
                        }

                        // if(Auth.getDecodedUser()){
                            store.dispatch(getAccumulatedOrderAmountSetting());
                        // }

                    }
                }
            }).catch(error => {
                throw (error);
            });
    }

} else {
    // production code
    let places = store.getState().places.places;
    if (places && Object.values(places).length > 0) {
        places = places.filter(p => p.visible_for_online_orders == 1);
    }
    let chosenPlace = store.getState().places.chosen_place;
    // FOR redirect after payment; ppid = payment place id
    const params = new URLSearchParams(window.location.search)
    if(params.has('payment') && params.has('ppid')) {
        chosenPlace = params.get('ppid');
    }
 
    // if(Object.keys(store.getState().client) == 0) {
    //     history.push("/404");
    // } else 
    if (places.length == 1 || chosenPlace != 0 || (Auth.isTabletMode() && Auth.getOpenedPlace())) {
        let placeId;
        if (Auth.isTabletMode() && Auth.getOpenedPlace()) {
            // за бъга при кики бийч с таблет mode-a, при смяна на плейсовете, трябваше 2 пъти да се избира плейса за да го сетне
            if(chosenPlace != Auth.getOpenedPlace() && chosenPlace != 0) {
                placeId = chosenPlace;
            } else {
                placeId = Auth.getOpenedPlace();
            }
        } else {    
            // placeId = places.length == 1 ? places[0].id : chosenPlace;
            placeId = chosenPlace ? chosenPlace : places.length == 1 ? places[0].id : chosenPlace;  // ako e skaniran token (napr: /t/6694ac209d1) -> ima chosenPlace, да си вземе директно него. Преди беше както е на горния ред..
        }

        setCustomPlaceHeader(placeId);  // only for dev

        store.dispatch(verifyOpenedPlace(placeId)); // if place is different -> clears local card, orders and token
        store.dispatch(setChosenPlace(placeId));

        // store.dispatch(getAllProducts(0, places[0].id));
        store.dispatch(getAllProducts(0));
        // store.dispatch(getCategoriesHierarchy(places[0].id))
        store.dispatch(getCategoriesHierarchy())

        // store.dispatch(getSettings(places[0].id));
        store.dispatch(getSettings());

        store.dispatch(getProductIngredients());
        store.dispatch(listLanguages());
        store.dispatch(getRegions());
        store.dispatch(getGeneralPromotions());
        store.dispatch(getRegisteredUserDiscounts());
        store.dispatch(getFutureOrdersCount());

        // if(Auth.getDecodedUser()){
            store.dispatch(getAccumulatedOrderAmountSetting());
        // }
    } else {
        store.dispatch({
            type: GET_PLACES,
            payload: places
        });
    }
}

store.dispatch(getProductsToOrder());
store.dispatch(getOrders());



// store.dispatch(getAllProducts());
// store.dispatch(getCategoriesHierarchy());

window.localStorage.setItem('hide_designes', 0); // OnRefresh reset "hide_designes" => Product themes options will be visible
window.localStorage.setItem('initial_translate', 1); // First initial translate flag

// }